export default {"src":"/_next/static/media/printIcon.99057120.svg","height":30,"width":30};